export default {"src":"/_next/static/media/icon-farmhouseBungalow.8aadfcb5.svg","height":17,"width":28,"blurWidth":0,"blurHeight":0};